<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="544px" height="77px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g><path :style="`fill:${accentColor}`" style="opacity:0.993"  d="M 24.5,-0.5 C 192.5,-0.5 360.5,-0.5 528.5,-0.5C 532.882,21.4245 537.882,43.0912 543.5,64.5C 543.5,65.5 543.5,66.5 543.5,67.5C 371.336,70.333 199.336,73.333 27.5,76.5C 23.1667,76.5 18.8333,76.5 14.5,76.5C 15.6289,66.109 16.7955,55.7756 18,45.5C 11.7612,42.6305 5.5945,39.6305 -0.5,36.5C -0.5,36.1667 -0.5,35.8333 -0.5,35.5C 6.91836,33.527 14.085,30.8603 21,27.5C 22.4956,18.1989 23.6622,8.86554 24.5,-0.5 Z"/></g>
  </svg>

</template>

<script>
export default {
  name: "NovelCalendarFukidashi",
  data() {
    return {
      accentColor: null,
    }
  },
  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.diaryAccent
  },
}
</script>

<style>

</style>